import type { TileResourceData } from '@/plugins/tiles/contracts'

/** 仅接受完整 GLB v2 容器所需的头；不把 HTTP 长度当作容器长度。 */
export function glbByteLength(data: TileResourceData): number | undefined {
  if (data.data.byteLength < 12) return undefined
  const header = new DataView(data.data)
  const length = header.getUint32(8, true)
  if (
    header.getUint32(0, true) !== 0x46546c67 ||
    header.getUint32(4, true) !== 2 ||
    length < 20 ||
    length % 4 !== 0 ||
    data.data.byteLength > length ||
    (data.complete && data.data.byteLength !== length) ||
    (data.totalBytes !== undefined && data.totalBytes !== length)
  )
    return undefined
  return length
}

/** 每个 Runtime 独占、一次性消费的标量提示；不保留响应或节点引用。 */
export class TileProbeHints {
  private readonly _entries = new Map<string, { identity: string; length: number; round: number }>()

  remember(id: string, identity: string, length: number, round: number): void {
    this._entries.delete(id)
    this._entries.set(id, { identity, length, round })
    if (this._entries.size > 256) this._entries.delete(this._entries.keys().next().value!)
  }

  take(id: string, identity: string, round: number): number | undefined {
    const hint = this._entries.get(id)
    this._entries.delete(id)
    return hint?.identity === identity && round - hint.round <= 2 ? hint.length : undefined
  }

  retain(wanted: ReadonlySet<string>, round: number): void {
    for (const [id, hint] of this._entries)
      if (!wanted.has(id) || round - hint.round > 2) this._entries.delete(id)
  }

  clear(): void {
    this._entries.clear()
  }
}
